import { createFileRoute } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import { z } from 'zod';
import { AuthGuard } from '@/components/auth-guard';
import { FolderDetailPage } from '@/features/files';

const LibrarySearchSchema = z.object({
  scope: z.enum(['private', 'public-downloads', 'article-assets', 'group']).optional(),
  group: z.string().optional(),
  partition: z.enum(['private', 'public-downloads', 'article-assets']).optional(),
});

function FolderDetailRoute(): ReactNode {
  const { folderId } = Route.useParams();
  const search = Route.useSearch();
  return (
    <AuthGuard>
      <FolderDetailPage folderId={folderId} search={search} />
    </AuthGuard>
  );
}

export const Route = createFileRoute('/library_/$folderId')({
  validateSearch: (search) => LibrarySearchSchema.parse(search),
  component: FolderDetailRoute,
});
